
import { mixin } from '@cems-eco/core/src/utils/platform';
import environment from "@/config";

import { BoxMaintenanceDetailComponent } from "./details.box";
import { CloudMaintenanceDetailComponent } from "./details.cloud";
import { DemoMaintenanceDetailComponent } from "./details.demo";

export default class Details extends mixin(environment.nexus, {
    box: BoxMaintenanceDetailComponent,
    cloud: CloudMaintenanceDetailComponent,
    demo: DemoMaintenanceDetailComponent,
}) { 
    [key: string]: any;
}
